import React from "react";
import "../../../AllComponentCSS.css";
import CodeCopyBlock from "../../../CodeCopyBlock";
import TryItButton from "../../../TryItButton";
import OutputBox from "../../../OutputBox";

export default function JS_IfElseIfElse() {
  return (
    <div className="tutorial-container read-only">
      <h1 className="tutorial-title">
        🎯 JavaScript if...else if...else Statement
      </h1>

      <p className="tutorial-intro">
        The <code className="highlight_code">if...else if...else</code>{" "}
        statement allows checking multiple conditions in sequence. It’s perfect
        for grading, feedback, or decision levels at Edu-Tech Master Academy.
      </p>

      <div
        className="Key_point_container"
        style={{ background: "linear-gradient(135deg, #dbeafe, #bfdbfe)" }}
      >
        <h2 style={{ color: "#1e40af" }}>🔑 Key Points</h2>
        <ul className="tutorial-list-points">
          <li>Checks multiple conditions in a specific order.</li>
          <li>Executes the first block whose condition is true.</li>
          <li>Useful for score ranges, levels, or feedback systems.</li>
        </ul>
      </div>

      {/* Example 1 */}
      <div className="tutorial-section">
        <h2 className="section-title">1️⃣ Student Grading Example</h2>
        <div className="code-demo-box read-only-box">
          <CodeCopyBlock
            code={`let score = 82;
if (score >= 90) {
  console.log("Grade A - Excellent Performance!");
} else if (score >= 75) {
  console.log("Grade B - Great Job at Edu-Tech Master Academy!");
} else if (score >= 50) {
  console.log("Grade C - Needs Improvement.");
} else {
  console.log("Fail - Please reattempt the test.");
}`}
          />
          <TryItButton
            code={`let score = 82;
if (score >= 90) {
  console.log("Grade A - Excellent Performance!");
} else if (score >= 75) {
  console.log("Grade B - Great Job at Edu-Tech Master Academy!");
} else if (score >= 50) {
  console.log("Grade C - Needs Improvement.");
} else {
  console.log("Fail - Please reattempt the test.");
}`}
          />
        </div>
        <OutputBox>
          <pre>Grade B - Great Job at Edu-Tech Master Academy!</pre>
        </OutputBox>
      </div>

      {/* Example 2 */}
      <div className="tutorial-section">
        <h2 className="section-title">2️⃣ Course Level Example</h2>
        <div className="code-demo-box read-only-box">
          <CodeCopyBlock
            code={`let experience = 3;
if (experience < 1) {
  console.log("Enroll in Beginner Level at Edu-Tech Master Academy.");
} else if (experience <= 3) {
  console.log("Intermediate Level Unlocked!");
} else {
  console.log("Welcome to the Advanced Course Track!");
}`}
          />
          <TryItButton
            code={`let experience = 3;
if (experience < 1) {
  console.log("Enroll in Beginner Level at Edu-Tech Master Academy.");
} else if (experience <= 3) {
  console.log("Intermediate Level Unlocked!");
} else {
  console.log("Welcome to the Advanced Course Track!");
}`}
          />
        </div>
        <OutputBox>
          <pre>Intermediate Level Unlocked!</pre>
        </OutputBox>
      </div>

      {/* Example 3 */}
      <div className="tutorial-section">
        <h2 className="section-title">3️⃣ Feedback Rating Example</h2>
        <div className="code-demo-box read-only-box">
          <CodeCopyBlock
            code={`let rating = 4;
if (rating === 5) {
  console.log("Outstanding! Thanks for supporting Edu-Tech Master Academy.");
} else if (rating === 4) {
  console.log("Great! We're glad you enjoyed it.");
} else if (rating === 3) {
  console.log("Good, but we can improve.");
} else {
  console.log("We're sorry, we'll do better next time.");
}`}
          />
          <TryItButton
            code={`let rating = 4;
if (rating === 5) {
  console.log("Outstanding! Thanks for supporting Edu-Tech Master Academy.");
} else if (rating === 4) {
  console.log("Great! We're glad you enjoyed it.");
} else if (rating === 3) {
  console.log("Good, but we can improve.");
} else {
  console.log("We're sorry, we'll do better next time.");
}`}
          />
        </div>
        <OutputBox>
          <pre>Great! We're glad you enjoyed it.</pre>
        </OutputBox>
      </div>
      {/* Next Steps */}
      <div
        style={{
          background: "linear-gradient(135deg, #c7d2fe, #a5b4fc)",
          padding: "1rem",
          borderRadius: "12px",
          marginTop: "2rem",
        }}
      >
        <h2 style={{ color: "#1e3a8a" }}>🚀 Next Steps</h2>
        <ul className="tutorial-list-points">
          <li>Experiment with more conditions in if...else if chains.</li>
          <li>
            Combine with nested <code className="highlight_code">if</code>{" "}
            statements for complex logic.
          </li>
          <li>
            Try using <code className="highlight_code">switch</code> for cleaner
            multi-branch logic.
          </li>
        </ul>
      </div>
    </div>
  );
}
